import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import STRINGS from "../Constants/Strings";

class OtpModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authCode: "",
      errors: {
        authCode: null,
      },
    };
  }

  componentDidUpdate(prevProps) {
    const { show, errors } = this.props;
    // Reset form when modal is opened
    if (!prevProps.show && show) {
      this.setState({
        authCode: "",
        errors: {
          authCode: null,
        },
      });
    }

    // Update errors from props if provided
    if (errors && errors !== prevProps.errors) {
      this.setState({
        errors: {
          authCode: errors.authCode || null,
        },
      });
    }
  }

  changeAuthCodeHandler = (event) => {
    const { errors } = this.state;
    const { onAuthCodeChange } = this.props;
    const errorObject = `${event.target?.name}`;
    // Only allow alphanumeric characters
    const alphanumericValue = event.target.value.replace(/[^0-9]/g, "");

    this.setState({
      [event.target.name]: alphanumericValue,
      errors: {
        ...errors,
        [errorObject]: null,
      },
    });

    // Notify parent component about the change
    if (onAuthCodeChange) {
      onAuthCodeChange(alphanumericValue);
    }
  };

  handleVerify = () => {
    const { authCode } = this.state;
    const { onVerify } = this.props;

    if (!authCode) {
      this.setState({
        errors: {
          authCode: [STRINGS.BRANCH.SIGNIN.OTP.ERRORS.REQUIRED],
        },
      });
    } else {
      this.setState(
        {
          errors: {
            authCode: null,
          },
        },
        () => {
          if (onVerify) {
            onVerify(authCode);
          }
        }
      );
    }
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleVerify();
    }
  };

  resendCode = () => {
    const { onResendCode } = this.props;
    if (onResendCode) {
      this.setState(
        {
          authCode: "",
          errors: {
            authCode: null,
          },
        },
        () => onResendCode()
      );
    }
  };

  render() {
    const {
      show,
      onHide,
      title,
      description,
      verifyingUser,
      verifyDisabled,
      onResendCode,
      showResendCode,
      verifyButtonText,
      verifyingButtonText,
      skipOtp,
    } = this.props;

    const { authCode, errors } = this.state;

    return (
      <Modal
        show={show}
        onHide={onHide}
        className="[ popup-modal__container ]"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static" // this prevents the pop up from being closed when clicked outside of the pop up
        keyboard={false}
      >
        <Modal.Header className="[ popup-modal__header ]" closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="[ row ]">
            <div className="[ col-12 ]">
              <div className="[ form-container ]">
                <div className="[ mb-3 ]">
                  <p style={{ textAlign: "center" }}>{description}</p>
                </div>
                {verifyingUser && (
                  <div
                    className="[ progress-indicator-container ]"
                    style={{ padding: "50px" }}
                  >
                    <div className="[ icon loading-icon fa-spin fa fa-spinner fa-4x ]" />
                    <span className="progress-message">&nbsp;</span>
                  </div>
                )}
                {!verifyingUser && (
                  <>
                    <div className="[ mb-3 ]">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="authCodeInput" className="[ form-label ]">
                        {STRINGS.BRANCH.SIGNIN.OTP.CODE_LABEL}
                      </label>
                      <input
                        id="authCodeInput"
                        type="text"
                        name="authCode"
                        className={
                          errors.authCode
                            ? "[ form-control ] [ is-invalid ]"
                            : "[ form-control ]"
                        }
                        placeholder={STRINGS.BRANCH.SIGNIN.OTP.CODE_PLACEHOLDER}
                        value={authCode}
                        onChange={this.changeAuthCodeHandler}
                        onKeyDown={this.handleKeyDown}
                        maxLength={10}
                        aria-describedby="authCodeHelp"
                      />
                      {errors.authCode && (
                        <div className="invalid-feedback">
                          {errors.authCode}&nbsp;
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
          {!verifyingUser && (
            <>
              <div className="[ mb-3 ]">
                <button
                  type="button"
                  className={`[ submit-btn btn ] [ w-100 ] ${
                    verifyingUser ? "hidden" : ""
                  }`}
                  onClick={this.handleVerify}
                  disabled={verifyDisabled}
                  style={{ borderRadius: ".5em" }}
                >
                  {verifyingUser ? verifyingButtonText : verifyButtonText}
                </button>
              </div>
            </>
          )}
          <div className="[ divider mb-3 d-flex align-items-center ]"></div>
          {showResendCode && (
            <>
              <div className="[ mb-3 text-center ]">
                <p>{STRINGS.BRANCH.SIGNIN.OTP.DID_NOT_RECEIVE}</p>
              </div>
              <div className="[ mb-3 text-center forgot-link ]">
                <span
                  className="[ link ]"
                  onClick={this.resendCode}
                  role="presentation"
                  style={{
                    textDecoration: "underline",
                    color: "#0090c6",
                    cursor: "pointer",
                  }}
                >
                  {STRINGS.BRANCH.SIGNIN.OTP.RESEND_CODE}
                </span>
                {skipOtp && (
                  <span
                    className="[ link ]"
                    onClick={skipOtp}
                    role="presentation"
                    style={{
                      textDecoration: "underline",
                      color: "#0090c6",
                      cursor: "pointer",
                      marginLeft: "1em",
                    }}
                  >
                    {STRINGS.BRANCH.SIGNIN.OTP.SKIP}
                  </span>
                )}
              </div>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

OtpModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  verifyingUser: PropTypes.bool,
  verifyDisabled: PropTypes.bool,
  onVerify: PropTypes.func.isRequired,
  onResendCode: PropTypes.func,
  skipOtp: PropTypes.func,
  onAuthCodeChange: PropTypes.func,
  showResendCode: PropTypes.bool,
  verifyButtonText: PropTypes.string,
  verifyingButtonText: PropTypes.string,
  errors: PropTypes.shape({
    authCode: PropTypes.arrayOf(PropTypes.string),
  }),
};

OtpModal.defaultProps = {
  title: STRINGS.BRANCH.SIGNIN.OTP.TITLE,
  description: STRINGS.BRANCH.SIGNIN.OTP.DESCRIPTION,
  verifyingUser: false,
  verifyDisabled: true,
  onResendCode: null,
  skipOtp: null,
  onAuthCodeChange: null,
  showResendCode: true,
  verifyButtonText: STRINGS.BRANCH.SIGNIN.OTP.VERIFY_BUTTON,
  verifyingButtonText: STRINGS.BRANCH.SIGNIN.OTP.VERIFYING_BUTTON,
  errors: {},
};

export default OtpModal;
